/**
 * @generated SignedSource<<6403b7a2e08e304bd0a81d933c0a6133>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ContentNotificationEmailCtaButton = "disabled" | "enabled" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type SendPreviewEmailInput = {
  body?: string | null;
  contentLabelId?: string | null;
  contentType: ContentType;
  createdById?: string | null;
  ctaUrl?: string | null;
  notificationEmailCtaButton?: ContentNotificationEmailCtaButton | null;
  organizationId: string;
  postTitle?: string | null;
  productId?: string | null;
  richEditorBody?: string | null;
  title?: string | null;
};
export type ContentFormPreviewEmailButtonMutation$variables = {
  input: SendPreviewEmailInput;
};
export type ContentFormPreviewEmailButtonMutation$data = {
  readonly sendPreviewEmail: boolean | null;
};
export type ContentFormPreviewEmailButtonMutation = {
  response: ContentFormPreviewEmailButtonMutation$data;
  variables: ContentFormPreviewEmailButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "sendPreviewEmail",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentFormPreviewEmailButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentFormPreviewEmailButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d273ecb64aaccd948b28125a57251094",
    "id": null,
    "metadata": {},
    "name": "ContentFormPreviewEmailButtonMutation",
    "operationKind": "mutation",
    "text": "mutation ContentFormPreviewEmailButtonMutation(\n  $input: SendPreviewEmailInput!\n) {\n  sendPreviewEmail(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "326c6e5421f92fba7fdeae790ee1cec6";

export default node;
